import { Ng2StateDeclaration } from '@uirouter/angular';
import { SimsConfigurationComponent } from './containers/sims-configuration/sims-configuration.component';


export const simsState: Ng2StateDeclaration = {
    // parent: 'app', // declares that 'pools' is a child of 'app'
    name: 'sim-config-list',
    url: '/project/:projectId/configuration/sims',
    component: SimsConfigurationComponent,
    params: {
        projectId: {squash: true, value: null}
    }
};

export const SIMS_STATES = [
    simsState
];
